"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _downscaleImageToDataURLUsingWorker = require("../../Utils/downscaleImageToDataURLUsingWorker");

var _BypassSpeechSynthesisPonyfill = require("../../Speech/BypassSpeechSynthesisPonyfill");

var _useLanguage3 = _interopRequireDefault(require("../useLanguage"));

var _useTrackDimension = _interopRequireDefault(require("../useTrackDimension"));

var _useTrackEvent = _interopRequireDefault(require("../useTrackEvent"));

var _useWebSpeechPonyfill3 = _interopRequireDefault(require("../useWebSpeechPonyfill"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function useTracker() {
  var _useLanguage = (0, _useLanguage3.default)(),
      _useLanguage2 = _slicedToArray(_useLanguage, 1),
      language = _useLanguage2[0];

  var _useWebSpeechPonyfill = (0, _useWebSpeechPonyfill3.default)(),
      _useWebSpeechPonyfill2 = _slicedToArray(_useWebSpeechPonyfill, 1),
      webSpeechPonyfill = _useWebSpeechPonyfill2[0];

  var trackDimension = (0, _useTrackDimension.default)();
  var trackEvent = (0, _useTrackEvent.default)(); // TODO: [P2] #2937 Track how many of them customized the following:
  // - activityMiddleware
  // - activityStatusMiddleware
  // - attachmentMiddleware
  // - cardActionMiddleware
  // - toastMiddleware
  // - styleOptions

  var speechRecognitionCapability = !!webSpeechPonyfill.SpeechRecognition;
  var speechSynthesisCapability = webSpeechPonyfill.speechSynthesis && webSpeechPonyfill.speechSynthesis !== _BypassSpeechSynthesisPonyfill.speechSynthesis;
  (0, _react.useEffect)(function () {
    trackDimension('prop:locale', language);
  }, [language, trackDimension]);
  (0, _react.useEffect)(function () {
    // TODO: [P2] #2937 Differentiate between Cognitive Services and browser speech
    trackDimension('prop:speechRecognition', !!speechRecognitionCapability + '');
  }, [trackDimension, speechRecognitionCapability]);
  (0, _react.useEffect)(function () {
    // TODO: [P2] #2937 Differentiate between Cognitive Services and browser speech
    trackDimension('prop:speechSynthesis', !!speechSynthesisCapability + '');
  }, [trackDimension, speechSynthesisCapability]);
  (0, _react.useEffect)(function () {
    trackDimension('capability:downscaleImage:workerType', (0, _downscaleImageToDataURLUsingWorker.checkSupport)() ? 'web worker' : 'main');
  }, [trackDimension]);
  (0, _react.useEffect)(function () {
    trackEvent('init');
  }, [trackEvent]);
}

var _default = useTracker;
exports.default = _default;